import { redirect } from 'next/navigation'
import { and, asc, eq } from 'drizzle-orm'
import { auth } from '@/auth'
import { db } from '@/db'
import { projects, tenantConfigs } from '@/db/schema'
import { loadTenantConfig } from '@/lib/tenant-config-loader'
import SubmitForm from './SubmitForm'

const CONFIG_PATH = process.env.TENANT_CONFIG_PATH ?? './tenant.config.yaml'

export default async function SubmitPage() {
  const session = await auth()
  if (!session?.user?.id) redirect('/login')

  const tenantId = session.user.tenantId

  const [config] = tenantId
    ? await db
        .select({
          submissionPromptText: tenantConfigs.submissionPromptText,
          submissionMaxChars: tenantConfigs.submissionMaxChars,
        })
        .from(tenantConfigs)
        .where(eq(tenantConfigs.tenantId, tenantId))
        .limit(1)
    : []

  const tenantConfig = loadTenantConfig(CONFIG_PATH)

  const activeProjects = tenantId
    ? await db
        .select({ id: projects.id, name: projects.name })
        .from(projects)
        .where(and(eq(projects.tenantId, tenantId), eq(projects.isActive, true)))
        .orderBy(asc(projects.name))
    : []

  return (
    <main className="min-h-screen bg-zinc-50 px-4 py-12 text-zinc-950 dark:bg-zinc-950 dark:text-zinc-100">
      <div className="mx-auto max-w-3xl">
        <h1 className="text-2xl font-semibold text-zinc-950 dark:text-white mb-2">Submit an Issue</h1>
        <p className="text-sm text-zinc-600 dark:text-zinc-400 mb-8">
          Complete all fields. An expert will respond as soon as possible.
        </p>
        <SubmitForm
          promptText={config?.submissionPromptText ?? 'Please describe the issue.'}
          maxChars={config?.submissionMaxChars ?? 4000}
          intakeConfig={tenantConfig.intake}
          initialProjects={activeProjects}
          waitingBody={tenantConfig.ui.post_submission_waiting_body}
          needsInfoBody={tenantConfig.ui.post_submission_needs_info_body}
          completeBody={tenantConfig.ui.post_submission_complete_body}
        />
      </div>
    </main>
  )
}
